import * as _ from "lodash";
import { Reducer } from "redux";
import {
  IJobsAction,
  JOB_BAN_SUCCESS,
  JOB_CANCEL_SUCCESS,
  JOB_DETAIL_FETCH_SUCCESS,
  JOBS_ERROR,
  JOBS_FETCH_SUCCESS
} from "../actions/jobs";
import { IJobsState } from "../types/job";

export const initialState: IJobsState = {};

const reducer: Reducer<IJobsState> = (
  state: IJobsState = initialState,
  action: IJobsAction
) => {
  switch (action.type) {
    case JOBS_FETCH_SUCCESS:
      return { jobs: action.payload.jobs, meta: action.payload.meta };
    case JOB_DETAIL_FETCH_SUCCESS:
      return { detail: action.payload.job };
    case JOB_BAN_SUCCESS:
      return {
        jobs: _.map(state.jobs, j => {
          return {
            ...j,
            is_banned: j.id === action.payload.id ? true : j.is_banned
          };
        })
      };
    case JOB_CANCEL_SUCCESS:
      return {
        jobs: _.map(state.jobs, j => {
          return j.id === action.payload.job.id ? action.payload.job : j;
        })
      };
    case JOBS_ERROR:
      return {
        error: action.message
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/jobs.ts